"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IconChevronDown = _interopRequireDefault(require("../../icons/General/IconChevronDown"));
var _Button = _interopRequireDefault(require("../Button"));
var _Input = _interopRequireDefault(require("../Input"));
var _List = _interopRequireDefault(require("../List"));
var _Select = require("../Select");
var _useSelectSearch = _interopRequireDefault(require("./hooks/useSelectSearch"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const SelectSearch = props => {
  const ref = (0, _react.useRef)(null);
  const inputRef = (0, _react.useRef)(null);
  const {
    open,
    values,
    search,
    setSearch,
    setOpen
  } = (0, _useSelectSearch.default)(props);
  const handleClickOutside = e => {
    const node = ref.current;
    if (node && node.contains(e.target)) return;
    setOpen(false);
    setSearch('');
  };
  (0, _react.useEffect)(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
      return;
    }
    document.removeEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, ref]);
  (0, _react.useEffect)(() => {
    if (open && inputRef.current) {
      inputRef?.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef?.current, open]);
  const handleOnClick = () => {
    setOpen(!open);
    if (!open) setSearch('');
  };
  const handleOnItemClick = item => () => {
    props.onChange(item);
    setOpen(false);
  };
  const getDisplayedValue = selected => {
    const item = values.find(v => v[props.keyName || 'id'] === selected);
    if (!item) return null;
    return props.createLabelName?.(item);
  };
  return (0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    ref: ref,
    css: () => [props.type === 'opacity08' && _styles.styles.opacity08],
    children: [props.label && (0, _jsxRuntime.jsx)(_styles.StyledLabel, {
      children: props.label
    }), (0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      afterIcon: (0, _jsxRuntime.jsx)(_IconChevronDown.default, {
        flipVertical: open,
        size: 14
      }),
      onClick: handleOnClick,
      trackingName: props.trackingName,
      trackingEvent: props.trackingEvent,
      children: props?.createLabelName && getDisplayedValue(props.selectedValue) || props.selectedValue || props.defaultValue || ''
    }), (0, _jsxRuntime.jsx)(_styles.OptionsWrapper, {
      children: open ? (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)(_Input.default, {
          ref: inputRef,
          height: "36px",
          type: "search",
          highlight: true,
          placeholder: props.inputPlaceholder || '',
          value: search,
          onChange: e => setSearch(e.target.value)
        }), (0, _jsxRuntime.jsx)(_styles.ListWrapper, {
          children: (0, _jsxRuntime.jsx)(_List.default, {
            children: values.map(item => (0, _jsxRuntime.jsx)(_Select.Option, {
              onChange: handleOnItemClick(item),
              children: props.createLabelName?.(item) || item[props.labelName || 'label']
            }, item[item.keyName || 'id']))
          })
        })]
      }) : null
    })]
  });
};
var _default = exports.default = SelectSearch;